import { axiosInstance } from "./axios";

export interface FeedbackRequest {
    entityType: string;
    entityId: string;
    feedbackValue: boolean;
}

export interface FeedbackResponse {
    id: number;
    entityType: string;
    entityId: string;
    feedbackValue: boolean;
    userOid: string;
    createdAt: string;
    updatedAt?: string;
}

export interface FeedbackStatsResponse {
    entityType: string;
    entityId: string;
    averageRating?: number;
    feedbackCount: number;
    positiveCount: number;
    negativeCount: number;
}

export const feedbackApi = {
    // Submit or update feedback (for any entity - game summaries, chat messages, etc.)
    submitFeedback: async (request: FeedbackRequest): Promise<FeedbackResponse> => {
        const response = await axiosInstance.post<FeedbackResponse>("/feedback", request);
        return response.data;
    },

    // Get feedback stats for any entity
    getFeedbackStats: async (entityType: string, entityId: string): Promise<FeedbackStatsResponse> => {
        const response = await axiosInstance.get<FeedbackStatsResponse>(`/feedback/${entityType}/${entityId}`);
        return response.data;
    },
};
